import React from 'react';
import { EditorWizardContext } from '../../../hoc/EditorWizard';
import { LocalizationContext } from '../../../hoc/Localization';
import localStyles from './styles.less';
import StepContainer from '../StepContainer';
import CourseSchoolImage from './courseSchoolImage';

const SelectImage = () => {
  const { t } = React.useContext(LocalizationContext);
  const { edited, step, updateContent } = React.useContext(EditorWizardContext);

  const { courseImage, schoolImage, image, email, schoolTitle, phone } = edited;

  const setValue = (data, key) => {
    updateContent(key, data);
  };
  const imageButtonText = t('course.create.wizard.upload.button');

  const imageSchool = schoolImage || image;

  return (
    <StepContainer
      nextButtonDisabled={!courseImage || !schoolImage}
      step={step}
      stepClassName={localStyles.stepLocal}
    >
      <CourseSchoolImage
        imageSchool={imageSchool}
        schoolTitle={schoolTitle}
        email={email}
        phone={phone}
        setValue={setValue}
        courseImage={courseImage}
        imageButtonText={imageButtonText}
        t={t}
      />
    </StepContainer>
  );
};

export default SelectImage;
